import { ENV } from '../config/env';

export const API_BASE_URL = ENV.API_BASE_URL;
export const SENTIMENT_API_BASE_URL = ENV.SENTIMENT_API_BASE_URL;

/** Re-export for services that encrypt outgoing request payloads. */
export const REQ_ENC_KEY = ENV.REQ_ENC_KEY;
